<template lang="html">
    <div class="print stock-note" v-if="company && freight && freight.id">
        <div class="header">
            <div class="left">
                <a href="http://www.flagmanamur.ru/client/" class="logo"><img src="/static/img/logo.png"></a>
            </div>
            <div class="right">
                <div class="info">
                    <span>{{company.name}}</span>
                    <br>
                    <span>{{'ИНН: ' + company.inn}}</span>
                    <br>
                    <span>{{'КПП: ' + company.kpp}}</span>
                </div>
                <div class="address">
                    <span v-if="companyAddress && companyAddress.id">{{companyAddress.address}}</span>
                    <br>
                    <span v-if="company && company.phone">{{'тел.: ' + company.phone}}</span>
                </div>
            </div>
        </div>
        <form method="POST">
            <h1 v-if="freight.traking_number">{{'Складская записка № ' + freight.traking_number}}</h1>
            <div class="main-content">

                <!-- данные для отправления -->
                <div class="wrapper">
                    <div class="heading">Данные отправления</div>

                    <div class="field" v-if="acceptedTracking && acceptedTracking.date">
                        <div class="col-1">Дата приёма груза:</div>
                        <div class="col-2">{{moment(acceptedTracking.date).format('DD.MM.YYYY')}}</div>
                    </div>
                    <div class="field" v-if="fromStock && fromStock.city">
                        <div class="col-1">Адрес сдачи груза:</div>
                        <div class="col-2">{{ fromStock.city.name + ', ' + fromStock.name }}</div>
                    </div>
                </div>

                <!-- данные назначения -->
                <div class="wrapper">
                    <div class="heading">Данные назначения</div>

                    <div class="field">
                        <div class="col-1">Пункт назначения:</div>
                        <div class="col-2" v-if="toCity && toCity.name">{{ toCity.name }}</div>
                    </div>
                </div>

                <!-- Характеристики груза -->
                <div class="wrapper" v-if="freight && freight.id">
                    <div class="heading">Характеристики груза</div>
                    <div class="field" v-if="freight.description">
                        <div class="col-1">Наименование груза:</div>
                        <div class="col-2">{{freight.description}}</div>
                    </div>
                    <div class="field" v-if="freight.seats_number">
                        <div class="col-1">Количество мест:</div>
                        <div class="col-2">{{freight.seats_number}}</div>
                    </div>
                    <div class="field" v-if="freight.weight">
                        <div class="col-1">Вес:</div>
                        <div class="col-2">{{freight.weight + ' кг'}}</div>
                    </div>
                    <div class="field" v-if="freight.size && freight.size_units">
                        <div class="col-1">Объем:</div>
                        <div class="col-2">{{ freight.size + ' ' + freight.size_units + '3'}}</div>
                    </div>
                </div>

                <!-- дополнительные услуги -->
                <!--
                 В данный раздел динамичен и генерируется на основе полученных/заполненных данных по грузу. В верстке приведены примеры параметров груза
                 -->
                <div class="wrapper" v-if="freight && freight.id">
                    <div class="heading">Дополнительные услуги</div>
                    <div class="field">
                        <div class="col-1">Требуется обрещётка:</div>
                        <div class="col-2">{{(parseInt(freight.doom) === 1) ? 'Да' : 'Нет'}}</div>
                    </div>
                    <div class="field">
                        <div class="col-1">Заводская упаковка:</div>
                        <div class="col-2">{{(parseInt(freight.factory_package) === 1) ? 'Да' : 'Нет'}}</div>
                    </div>

                    <div v-if="freight.services && freight.services.length">
                        <div class="field" v-for="service in freight.services">
                            <div class="col-1">
                                {{ (service.service.type == 'radio' || service.service.type == 'select') ? service.service.name : service.name }}
                            </div>
                            <div class="col-2">
                                {{ (service.service.type == 'radio' || service.service.type == 'select') ? service.name : 'Да' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Данные плательщика -->
                <!-- В этом блоке выводятся данные плательщика:
                если выбран отправитель — выводим его данные
                если выбран получатель — выводим его данные
                если выбрано 3 лицо — тогда выводим данные заполненные для него
                -->
                <div class="wrapper">
                    <div class="heading">Прочие данные приема</div>
                    <div class="field">
                        <div class="col-1">Кладовщик:</div>
                        <div class="col-2">Иванов И.И.</div>
                    </div>
                </div>

                <!-- Данные подписи клиента -->
                <div class="wrapper">
                    <div class="heading">Подпись клиента</div>
                    <div class="sign" v-if="deal && deal.from_signature" >
                        <img style="width: 250px; height: 100px; margin: 0 auto;" v-bind:src="deal.from_signature">
                    </div>
                    <div class="sign" v-else>
                        <img v-if="freight && freight.from_signature" v-bind:src="freight.from_signature" style="width: 250px; height: 100px; margin: 0 auto;">
                    </div>
                </div>
                <!-- Данные qr -->
                <div class="wrapper">
                    <div class="heading">Данные для отслеживания груза</div>
                    <div class="field">
                        <div class="col-1">№ груза для отслеживания:</div>
                        <div class="col-2">{{freight.traking_number}}</div>
                    </div>
                    <div class="img">
                        <div class="qr">
                            <canvas ref="qr"></canvas>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>
</template>
<script>
  import moment from "moment";
  import QRCode from "qrcode";
  export default {
    components: {QRCode},
    data() {
      return {
        loading: false,
        data: {
          id: '',
          from_signature: '',
          company: {
            name: '',
            inn: '',
            kpp: '',
          },
          freight: {
            name: '',
            created_at: '',
            seats_number: '',
            weight: '',
            volume: ''
          },
          from: {
            name: 'Хабаровск'
          },
          to: {
            name: 'Облучье'
          },
          services: []
        },
        deal: {},
        freight: {},
        company: {},
        acceptedTracking: {},
        fromStock: {},
        toCity: {},
        isPrint: false,
      }
    },
    watch: {
    },
    computed: {
      user() {
        return this.$store.state.users.current;
      },
      companyAddress() {
          if (!this.company || !this.company.addresses) return [];
          return this.company.addresses.find(item => !!item);
      }
    },
    methods: {
      init() {
        this.$store.commit('setPrint', true);
        this.getFreight(this.$route.query.freight_id).then(freight => {
            if (!freight || !freight.id || !freight.deal || !freight.deal.id) {
              alert('Возникла ошибка при печати: Отсутвуют обазательные параметры заявки или груза');
              return;
            }

            this.deal = Object.assign({}, freight.deal);
            let promises = [];

            let QR = new Promise((resolve, reqject) => {
                QRCode.toCanvas(this.$refs.qr, freight.traking_number, {width: 250}, function (error) {
                    if (error) reqject('Возникла ошибка при печати: ' + error);
                    else resolve();
                });
            });
            promises.push(QR);

            this.getTracking(freight.id).then(r => {
                if (!r || !r.data || !freight.deal || !freight.deal.executor_company_id || !freight.deal.to_city_id) {
                    alert('Возникла ошибка при печати: Отсутвуют обазательные параметры трекинга');
                    return;
                }
                new Promise((resolve, reject) => {
                    this.acceptedTracking = Object.assign({}, r.data.find(item => !!item));
                    this.$nextTick(() => resolve(this.acceptedTracking));
                }).then(() => {
                    promises.push(this.getStock(this.acceptedTracking.stock_id).then(r => {
                        this.fromStock = Object.assign({}, r);
                        return r;
                    }));
                    promises.push(this.getCity(freight.deal.to_city_id).then(r => {
                        this.toCity = Object.assign({}, r);
                        return r;
                    }));
                    promises.push(this.getCompany(freight.deal.executor_company_id));

                    let $this = this;
                    Promise.all(promises.map(p => p.catch(e => e))).then(() => {
                        $this.closePageListener();
                        //setTimeout нужен чтобы успел отрендериться DOM, $nextTick не помогает
                        setTimeout(() => window.print(), 1000);
                    });

                });
            });
        });
      },
      prepareData() {
          return new Promise((resolve, reject) => {
              this.data.freight.name         = this.freight.description;
              this.data.freight.created_at   = moment(this.freight.created_at, 'YYYY-MM-DD HH:mm:ss').format('Do MMMM YYYY (DD.MM.YYYY)');
              this.data.freight.seats_number = this.freight.seats_number;
              this.data.freight.weight       = this.freight.weight;
              this.data.freight.volume       = this.freight.size + ' ' + this.freight.size_units;
              this.data.from_signature       = this.freight.from_signature;
              this.data.freight_tracking     = this.freight.traking_number;
              this.data.services = Object.assign({}, this.freight.services);
              this.data.company.name = this.company.name;
              this.data.company.inn  = this.company.inn;
              this.data.company.kpp  = this.company.kpp;
              resolve();
          });
      },
      getCompany(id) {
        return this.$store.dispatch('companies/getCompany', {id: id}).then(r => {
          if (r) this.company = Object.assign({}, r);
          return r;
        });
      },
      getFreight(id) {
        return this.$store.dispatch('storekeepers_stocks/getFreight', id).then(r => {
          if (r && r.id) {
            this.freight = Object.assign({}, r);
            return r;
          }
        });
      },
      getTracking(freightId) {
        return this.$store.dispatch('storekeepers_stocks/getTracking', {
            filter: {
                model: [['freight_id', '=', freightId]],
                relation: [['status', 'code', '=', 'storekeeper_accepted_from_client']],
                condition: 'and'
            }
        });
      },
      getStock(id) {
        return this.$store.dispatch('stock/getStock', {id: id});
      },
      getCity(id) {
        return this.$store.dispatch('storekeepers_stocks/getCity', id);
      },
      /**
       * Функция слушает нажатие кнопок "Отмена" и "Печать"
       * на форме печати браузера, и если нажали "Отмена", закрывает страницу
       */
      closePageListener() {
        if (window.matchMedia) {
          window.matchMedia('print').addListener(mql => {
            if (!mql.matches) window.close();
          });
        }
      }
    },
    created() {
      this.$nextTick(() => this.init());
    }
  }
</script>
<style src="./FreightPrintStockNote.css" lang="css" media="print"></style>
<style lang="sass">
  #print
    display: none
    font-family: Arial, sans-serif
    background: #fff
    font-size: 12px
    padding: 10px
    width: calc(7.2 * 37.7952755905511px)
    .company-title
      font-size: 15px
      text-align: center
    .page-title
      text-align: center
      font-size: 20px
    .section
      .section-title
        font-size: 15px
        font-weight: bold
        margin: 10px 0
        text-align: center
    .item-value
      display: flex
      justify-content: space-between
      flex-wrap: wrap
      border-bottom: 1px solid #000
      margin-bottom: 5px
      label
      .value
    .qr
      display: flex
      align-items: center
      justify-content: center

  @media print
    @page
      size: auto //auto is the initial value
      margin: 0  //this affects the margin in the printer settings
    #print
      display: block
</style>



// WEBPACK FOOTER //
// FreightPrintStockNote.vue?63ba720e